import React from "react";

import { Grid } from "@material-ui/core";

import AverageDailyFootfallLevel from "./AverageDailyFootfallLevel";
import AverageDailyFootfallLevelMeasure from "./AverageDailyFootfallLevelMeasure";
import AverageDailyFootfallLevelTitle from "./AverageDailyFootfallLevelTitle";

const FootfallAlignment: React.FC = () => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <AverageDailyFootfallLevelMeasure />
            </Grid>
            <Grid item xs={12}>
                <AverageDailyFootfallLevelTitle />
            </Grid>
            <Grid item xs={12}>
                <AverageDailyFootfallLevel />
            </Grid>
        </Grid>

    );
};

export default FootfallAlignment;
